import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../../hooks/useAuth'
import { ROUTES } from '../types'

interface RoleGuardProps {
  children: ReactNode
  requiredRoles: string[]
}

export function RoleGuard({ children, requiredRoles }: RoleGuardProps) {
  const { user } = useAuth()

  const userRole = user?.role || 'viewer'
  const hasRequiredRole = requiredRoles.includes(userRole)

  if (!hasRequiredRole) {
    return <Navigate to={ROUTES.HOME} replace />
  }

  return <>{children}</>
}
